// extracted by mini-css-extract-plugin
export default {"organization_slider":"OrganizationSlider_organization_slider__U4cxP","img_container":"OrganizationSlider_img_container__p8tix"};